module.exports = __webpack_public_path__ + "static/img/news_xiangqing_tu5.f98d951.png";


//////////////////
// WEBPACK FOOTER
// ./static/img/news_xiangqing_tu5.png
// module id = VFdc
// module chunks = 0